var map = {
	"./Add-Salesperson.mp4": 39606,
	"./Add-retailer.mp4": 80709,
	"./AddPerson-1.png": 23353,
	"./AddPerson-2.png": 15622,
	"./AddPerson-3.png": 42120,
	"./AddPerson-4.png": 930,
	"./Assign-1.png": 29161,
	"./Assign-visit.mp4": 20666,
	"./Currency-1.png": 39915,
	"./Currency-2.png": 15979,
	"./Currency-3.png": 26820,
	"./Currency-4.png": 34392,
	"./DB-1.png": 27530,
	"./DB-2.png": 41812,
	"./DB-3.png": 10262,
	"./DB-4.png": 49755,
	"./Graph-1.png": 60498,
	"./Log-1.png": 55901,
	"./Log-2.png": 57005,
	"./Notify-1.png": 70334,
	"./Notify-2.png": 54356,
	"./Profile-1.png": 10594,
	"./Profile-2.png": 63046,
	"./Profile-3.png": 88756,
	"./Profile-4.png": 54717,
	"./RA-1.png": 75950,
	"./RA-2.png": 24970,
	"./RA-3.png": 15742,
	"./RA-4.png": 58749,
	"./RemovePerson-1.png": 96209,
	"./Setting1.png": 4810,
	"./Target-1.png": 79971,
	"./Target-2.png": 19480,
	"./Target-3.png": 70929,
	"./ViewInfo-1.png": 788,
	"./ViewSales-1.png": 92728,
	"./ViewSales-2.png": 63474,
	"./ViewSales-3.png": 95162,
	"./import-1.png": 25296,
	"./import-2.png": 56560,
	"./import-3.png": 81287,
	"./order-1.png": 46109,
	"./order-2.png": 81853,
	"./order-3.png": 69298,
	"./product-1.png": 91207,
	"./product-2.png": 42864,
	"./product-3.png": 12419,
	"./transaction-1.png": 64525,
	"./transaction-2.png": 82647,
	"./transaction-3.png": 85476,
	"./vendor-1.png": 80221,
	"./vendor-2.png": 67353,
	"./vendor-3.png": 43072,
	"./vendor-4.png": 72987,
	"./visits-1.png": 11984,
	"./visits-2.png": 38554,
	"./visits-3.png": 17023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21471;